import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export interface DeleteTeamReq {
  /** 验证码 */
  code?: string
}

@Injectable()
export class TeamInfoEditService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  deleteTeam (data: DeleteTeamReq) {
    return this.http.post('/team/cancel', data)
  }
}
